import Image from 'next/image';
import { type FC } from 'react';

import NoodleTheme from '@/components/NoodleTheme';

import s from './PoweredByNoodle.module.scss';

type Props = {
  style?: React.CSSProperties;
  isVertical?: boolean;
  utm?: string;
};

const PoweredByNoodle: FC<Props> = ({ style, isVertical, utm }) => (
  <NoodleTheme>
    <div className={s.wrapper} style={style} data-translate='false'>
      <a
        className={isVertical ? s.poweredVertical : s.powered}
        target='_blank'
        rel='noopener noreferrer'
        href={`https://www.glade.ai${utm ? `/?utm_source=${utm}` : ''}`}
      >
        Powered by <Image src='/full-glade-logo.png' width={72} height={16} alt='Glade AI' />
      </a>
    </div>
  </NoodleTheme>
);

export default PoweredByNoodle;
